import { useState } from 'react'
import { VectorSearch } from '@/components/knowledge/vector-search'
import { FAQDetail } from '@/components/knowledge/faq-detail'
import { PageWrapper } from '@/components/animated/page-wrapper'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'

export function SearchPage() {
  const [selectedResult, setSelectedResult] = useState<any>(null)

  const handleSelectResult = (result: any) => {
    setSelectedResult(result)
  }

  const handleBack = () => {
    setSelectedResult(null)
  }

  return (
    <PageWrapper>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-light tracking-tight text-foreground">Intelligente Suche</h1>
          <p className="text-muted-foreground">
            Nutzen Sie KI-gestützte Suche für präzise Ergebnisse
          </p>
        </div>

        {/* Content */}
        {selectedResult ? (
          <div className="space-y-4">
            <Button
              variant="outline"
              onClick={handleBack}
              className="mb-4"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Zurück zur Suche
            </Button>

            <FAQDetail
              faq={selectedResult}
              onClose={handleBack}
            />
          </div>
        ) : (
          <VectorSearch onSelectResult={handleSelectResult} />
        )}
      </div>
    </PageWrapper>
  )
}